export default {
    unassignedOrdersDescription: 'Les commandes non attribuées sont toujours incluses.',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    last7Days: 'Derniers 7 jours',
    last2Weeks: 'Dernières 2 semaines',
    lastMonth: 'Dernier mois',
    last3Months: 'Derniers 3 mois',
    monthToDate: "Mois jusqu'à aujourd'hui",
    quarterToDate: "Trimestre jusqu'à aujourd'hui",
    yearToDate: "Année jusqu'à aujourd'hui",
    onlyUnassignedOrders: 'Uniquement les commandes non attribuées',
    selectMode: 'Sélectionner le mode',
    selectDateFieldPlaceholder: 'Sélectionnez un champ de date...',
    reset: 'Réinitialiser',
    selectStatuses: 'Sélectionner le(s) statut(s)',
    selectDistributionZones: 'Sélectionner le(s) terminal(aux)',
    selectClients: 'Sélectionner le(s) client(s)',
    firebase10Limit: 'Limite de 10',
    distributionZones: 'terminaux',
    selectCategories: 'Sélectionner la(les) catégorie(s)',
    selectManufacturers: 'Sélectionner le(s) fabricant(s)',
    customViews: 'Vues personnalisées',
    fetchRecords: 'Récupérer les enregistrements',
    goToRecords: 'Aller aux enregistrements',
    goToRoutes: 'Aller aux itinéraires',
    goToMapFleet: 'Aller à la carte et à la flotte',
    goToReport: 'Aller au rapport',
    goToLiveConnect: 'Aller à Live Connect',
    goToAdmin: 'Aller à Admin',
    openSearch: 'Ouvrir la recherche',
    createDedicatedOrder: 'Créer une commande dédiée',
    createSingleOrder: 'Créer une commande simple',
    openBulkImport: "Ouvrir l'importation en masse",
    checkBackLater: 'Venez consulter plus tard',
    notApplicable: 'N/A',
    warning: 'Avertissement',
    language: 'Langue',
    'Coming Soon': 'Bientôt disponible!',
    loadingMessage: 'CONDUIRE DE MEILLEURES AFFAIRES ET EXPÉRIENCES CLIENT',
    loadingMessage2: "La Solution Complète de Chaîne d'Approvisionnement",
    loading: 'Chargement...',
    ItemNumber: "Numéro d'article",
    PrintQuantity: 'Quantité à imprimer',
    dateRegion: {
        Records: 'Enregistrements',
        selectRequiredFields: 'Veuillez sélectionner le champ de date, le(s) client(s) et le(s) terminal(aux)',
        orderCountToCheck: {
            one: '{{needToCheckDispatch}} commande nécessite attention',
            other: '{{needToCheckDispatch}} commandes nécessitent attention',
        },
        buttons: {
            addUpload: 'Ajouter/Télécharger',
            dedicatedOrder: 'Commande dédiée',
            order: 'Commande',
            upload: 'Télécharger',
        },
        supplyChain: {
            status: {
                pending: 'En attente',
                processing: 'En cours',
                shipped: 'Expédié',
                delivered: 'Livré',
            },
            inventory: {
                low: 'Stock faible',
                outOfStock: 'Rupture de stock',
                available: 'En stock',
            },
        },
        customerShipmentNotification: {
            title: 'Nouveaux Expéditions Clients',
            message: 'Les clients ont placé expéditions depuis le portail',
            info: 'Chaque expédition comprend généralement à la fois le ramassage et la livraison',
            closeAriaLabel: 'Fermer la notification',
        },
    },
    nav: {
        header: {
            headerTitle: 'Enregistrements',
        },
    },
    viewSettings: {
        deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette vue ?',
        deleteWarning: 'Cela supprimera la vue "{{name}}" et tous ses paramètres.',
        delete: 'Supprimer',
        cancel: 'Annuler',
        noViews: 'Aucune vue trouvée',
        emptyState: {
            title: 'Aucune vue disponible',
            description: 'Enregistrez vos filtres et plages de dates préférés comme vues pour y accéder plus tard. Partagez des vues avec des parties externes pour un accès rapide en lecture seule.',
            createFirstView: 'Créez votre première vue pour commencer'
        },
        shareLink: 'Partager le lien',
        type: 'Type',
        regions: 'Régions',
        clients: 'Clients',
        dateRange: 'Plage de dates',
        copyLink: 'Copier le lien',
        sharingSettings: 'Paramètres de partage',
        warning: {
            accessClientZones: `Vous n'avez pas accès aux clients ou aux zones de distribution de la vue.`,
            selectView: 'Vous devez créer une nouvelle vue ou charger la vue enregistrée depuis le menu Vues',
            bindClientZones: `Cette vue n'a pas de client et de zone de distribution liés. Veuillez créer une nouvelle vue avec liaison`,
        },
        createNewView: 'Créer une nouvelle vue',
        name: 'Nom',
        enterName: 'Entrez le nom de la vue...',
        configurationSaved: 'Ce que cette vue enregistrera',
        visibleColumns: 'Colonnes visibles',
        columnOrder: 'Ordre des colonnes',
        grouping: 'Groupement',
        appliedFilters: 'Filtres appliqués',
        create: 'Créer la vue',
        personal: 'Personnel',
        shared: 'Partagé',
        bindClientDistributionzones: 'Enregistrer les clients, zones de distribution et la plage de dates actuels',
        bindClientZonesHelp: 'Les clients et les zones sont rechargés avec la vue. La plage de dates n’est enregistrée que pour le lien externe : dans le portail, la vue suit la plage de dates que vous avez sélectionnée. Sans cette option, la vue utilise les clients et zones du moment et applique uniquement l’option de date ci-dessus.',
        columnLayoutSaved: 'La disposition actuelle des colonnes — quelles colonnes sont visibles et dans quel ordre — est toujours enregistrée.',
        shareExternally: 'Créer un lien externe partageable',
        shareExternallyHelp: 'Toute personne disposant du lien peut ouvrir cette vue sans se connecter. Vous pouvez à tout moment ajouter un mot de passe, autoriser la copie ou désactiver le lien depuis les paramètres de la vue.',
        shareExternallyRequires: 'Activez d’abord l’option ci-dessus. Un lien partagé n’a aucun utilisateur connecté dont il pourrait reprendre les clients, zones et plage de dates ; il ne fonctionne donc que sur une vue qui a enregistré les siens.',
        linkAvailableAfterCreate: 'Le lien est généré à la création de la vue. Vous pourrez ensuite le copier depuis les paramètres de la vue.',
        copyToClipboard: 'Lien copié dans le presse-papiers. Vous pouvez maintenant le partager',
        hasClientZones: 'Cette vue inclut des clients et zones de distribution liés',
        passwordProtected: 'Cette vue est protégée par mot de passe',
        error: {
            fetchFailed: 'Échec de la récupération des vues. Veuillez réessayer.',
            copyFailed: 'Échec de la copie du lien. Veuillez réessayer.',
            updateFailed: 'Échec de la mise à jour de la vue. Veuillez réessayer.',
            deleteFailed: 'Échec de la suppression de la vue. Veuillez réessayer.',
        },
        sharedView: {
            setPassword: {
                title: 'Un mot de passe est requis pour afficher ce contenu',
                subTitle: 'Ce mot de passe n\'est pas le même que le mot de passe de votre compte Shyftbase',
            },
            allowCopy: 'Autoriser la copie de données',
            showAllFields: 'Afficher tous les champs dans les enregistrements développés',
            restrictAccess: 'Restreindre par mot de passe',
            disable: 'Désactiver le lien',
            enable: 'Activer le lien',
            notAvailable: {
                title: 'Le lien de partage privé que vous avez essayé d\'atteindre n\'est pas disponible.',
                subTitle:
                    'Le propriétaire de cette vue peut l\'avoir annulé ou supprimé. Veuillez le contacter si vous avez besoin d\'accès.',
            },
            verifyPassword: 'Entrez le mot de passe pour afficher le contenu',
            wrongPassword: 'Mot de passe incorrect. Veuillez réessayer.',
        },
        new: 'Nouveau',
        searchViews: 'Rechercher des vues...',
        personalViews: 'Vues personnelles',
        noPersonalViews: 'Aucune vue personnelle trouvée.',
        sharedViews: 'Vues partagées',
        noSharedViews: 'Aucune vue partagée trouvée.',
        startWindow: 'Fenêtre de début',
        manageSharing: 'Paramètres de la vue',
        sharedViaLink: 'Partagée via un lien externe',
        pullScope: 'Données récupérées',
        tableLayout: 'Disposition du tableau',
        groupedBy: 'Groupé par',
        filters: 'Filtres',
        notGrouped: 'Non groupé',
        noFilters: 'Aucun filtre',
        dateBasis: 'Date',
        dateRangeExternalOnly: 'Utilisé uniquement par le lien externe. Dans le portail, cette vue utilise toujours la plage de dates que vous avez sélectionnée.',
        allZones: 'Toutes les zones de distribution',
        allClients: 'Tous les clients',
        none: 'Aucun',
        dateOptions: {
            today: "Aujourd'hui",
            tomorrow: 'Demain',
            yesterday: 'Hier',
            none: 'Aucune date enregistrée',
        },
        howToUpdate: {
            title: 'Comment mettre à jour cette vue',
            layout: 'Disposition du tableau — organisez les colonnes, le groupement et les filtres dans la grille, puis cliquez sur l’icône de sauvegarde de cette vue dans le panneau.',
            scope: 'Clients, zones et plage de dates — seules les vues enregistrées avec les clients et zones de distribution actuels les conservent. Modifiez-les dans le formulaire de récupération, lancez la récupération, puis cliquez sur sauvegarder. La plage de dates enregistrée n’est utilisée que par le lien externe ; dans le portail, cette vue suit toujours la plage de dates que vous avez sélectionnée.',
            fixed: `Le nom, le mode et le rattachement à des clients et zones de distribution précis sont fixés à la création. Créez une nouvelle vue pour les modifier. (Cela n'affecte pas le lien de partage ci-dessus, que vous pouvez activer ou désactiver à tout moment.)`,
        },
    },
    dashboard: {
        title: 'Tableau de Bord',
        shyftbaseWatch: 'Surveillance Shyftbase',
        shyftbaseWatchSubtitle: 'La surveillance Shyftbase s\'active une fois que suffisamment de données sont collectées',
        shyftbaseWatchModal: {
            title: 'Surveillance Shyftbase',
            message: 'La surveillance Shyftbase s\'active une fois que suffisamment de données sont collectées.',
            buttonText: 'Aller à l\'Onglet Enregistrements',
            closeAriaLabel: 'Fermer la modale',
        },
        operationsOverview: 'Vue d\'ensemble des Opérations',
        orderCount: 'Nombre de Commandes',
        unconfirmedPercent: 'Non confirmé %',
        confirmedPercent: 'Confirmé %',
        invoicedPercent: 'Facturé %',
        activeRoutes: 'Itinéraires Actifs',
        fleetUtilization: 'Utilisation de la Flotte',
        avgDeliveryTime: 'Temps de Livraison Moyen',
        ordersNeedingAttention: 'Commandes nécessitant une attention',
        noOrdersNeedAttention: 'Aucune commande ne nécessite actuellement d\'attention.',
        noOrdersDescription: 'Lorsque vous aurez des commandes nécessitant une action, elles apparaîtront ici avec des détails tels que :',
        noOrdersExamples: {
            addressVerification: 'Vérification d\'adresse nécessaire',
            schedulingConflicts: 'Conflits de planification de livraison',
            paymentVerification: 'Vérification de paiement en attente',
            specialHandling: 'Exigences de manipulation spéciale',
        },
        recommendations: 'Recommandations',
        noRecommendations: 'Aucune recommandation n\'est encore disponible.',
        noRecommendationsDescription: 'Au fur et à mesure que votre système collecte des données opérationnelles, des informations basées sur l\'IA apparaîtront ici, notamment :',
        noRecommendationsExamples: {
            routeOptimization: 'Opportunités d\'optimisation d\'itinéraire',
            capacityPlanning: 'Suggestions de planification de capacité',
            preventiveMaintenance: 'Alertes de maintenance préventive',
            costSaving: 'Recommandations d\'économie de coûts',
        },
        quickActions: {
            title: 'Actions Rapides',
            orderTable: {
                title: 'Table des Commandes',
                description: 'Console d\'opérations et d\'expédition en direct',
            },
            uploadCsv: {
                title: 'Télécharger CSV',
                description: 'Importation en masse de commandes',
            },
            liveConnect: {
                title: 'Live Connect',
                description: 'Approuver/rejeter les demandes des clients',
            },
            mapFleet: {
                title: 'Carte de la Flotte',
                description: 'Surveiller la flotte et les itinéraires',
            },
            search: {
                title: 'Rechercher',
                description: 'Recherches de support client',
            },
            reports: {
                title: 'Rapports',
                description: 'Perspectives opérationnelles',
            },
            admin: {
                title: 'Admin',
                description: 'Paramètres et configuration',
            },
        },
        dataPending: {
            title: 'Chargement des Données...',
            description: 'Les données opérationnelles apparaîtront ici une fois que le système recevra et traitera les commandes.',
        },
    },
    notification: {
        accessDenied: 'Accès refusé. Veuillez vérifier votre niveau d\'accès.',
        orderAssignment: 'Attribution de commande',
        assigned: 'Attribué',
        unassigned: 'Non attribué',
        orderAssignmentSubtitle: 'Les commandes non attribuées n\'ont pas encore de date cible',
        parametersRemoved: '{{parameters}} ont été supprimés car ils ne sont pas valides pour les commandes non attribuées.',
    }    
}
